import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdaService } from 'src/app/shared/services/pda.service';
import { Alert } from 'src/app/shared/models/alert.model';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit {
  @Input() title: any;
  @Input() from: string;
  @Input() data: any;
  content: string;
  return: boolean = false;
  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();
  @Output() clickReturn = new EventEmitter();
  constructor(
    public activeModal: NgbActiveModal,
    private _translate: TranslateService,
    private modalService: NgbModal,
    private pda: PdaService
  ) {}

  ngOnInit(): void {}
  btnClose() {
    this.clickClose.emit(this.data.id);
    this.activeModal.close();
  }

  btnDismiss() {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }
  returnToActives() {
    this.return = !this.return;
    this.clickClose.emit(this.data.id);
  }
}
